import React from 'react';
import { Badge } from '@/components/ui/badge';

const statusStyles = {
  HEALTHY: 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok))]/25',
  DEGRADED: 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))] border-[hsl(var(--status-warn))]/25',
  CRITICAL: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
  UNKNOWN: 'bg-[hsl(var(--status-unknown))]/15 text-[hsl(var(--status-unknown))] border-[hsl(var(--status-unknown))]/25',
  ACTIVE_MONITORING: 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok))]/25',
  IN_PROGRESS: 'bg-[hsl(var(--status-info))]/15 text-[hsl(var(--status-info))] border-[hsl(var(--status-info))]/25',
  DETECTED: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
  INVESTIGATING: 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))] border-[hsl(var(--status-warn))]/25',
  AWAITING_APPROVAL: 'bg-[hsl(var(--status-info))]/15 text-[hsl(var(--status-info))] border-[hsl(var(--status-info))]/25',
  APPROVAL_PENDING: 'bg-[hsl(var(--status-info))]/15 text-[hsl(var(--status-info))] border-[hsl(var(--status-info))]/25',
  ESCALATED: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
  RESOLVED: 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok))]/25',
  SLA_PENDING: 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))] border-[hsl(var(--status-warn))]/25',
  ASSESSMENT_FAILED: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
  FULLY_SUPPORTABLE: 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok))]/25',
  PARTIALLY_SUPPORTABLE: 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))] border-[hsl(var(--status-warn))]/25',
  NOT_SUPPORTABLE: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
  ON_TRACK: 'bg-[hsl(var(--status-ok))]/15 text-[hsl(var(--status-ok))] border-[hsl(var(--status-ok))]/25',
  AT_RISK: 'bg-[hsl(var(--status-warn))]/15 text-[hsl(var(--status-warn))] border-[hsl(var(--status-warn))]/25',
  BREACHED: 'bg-[hsl(var(--status-crit))]/15 text-[hsl(var(--status-crit))] border-[hsl(var(--status-crit))]/25',
};

export const StatusBadge = ({ status, className = '' }) => {
  const style = statusStyles[status] || statusStyles.UNKNOWN;
  const label = status ? status.replace(/_/g, ' ') : 'Unknown';
  return (
    <Badge
      variant="outline"
      className={`text-xs font-medium border ${style} ${className}`}
      data-testid="status-badge"
    >
      {label}
    </Badge>
  );
};

export default StatusBadge;
